import React from 'react';
import { useThemeColors } from '../../hooks/useTheme';
import { useNavigate } from 'react-router-dom';
import { projects } from '../../data/projects';
import './Projects.scss';

const Projects: React.FC = () => {
  const colors = useThemeColors();
  const navigate = useNavigate();

  const handleProjectClick = (projectId: number) => {
    navigate(`/projects/${projectId}`);
  };

  return (
    <section id="projects" className="projects" style={{ 
                '--background': colors.background,
                '--surface': colors.surface,
                '--surface1': colors.surface1,
                '--primary': colors.primary,
                '--text': colors.text,
                '--accent': colors.accent,
                '--border': colors.border,
              } as React.CSSProperties}
              >
      <div className="projects__container">
        <h2 className="projects__title">Featured Projects</h2>
        <p className="projects__subtitle">
          Here are some of my most significant projects.
        </p>
        
        <div className="projects__grid">
          {projects.map(project => (
            <article 
              key={project.id}
              className="projects__card"
              onClick={() => handleProjectClick(project.id)}
              style={{
                backgroundColor: colors.surface,
                border: `1px solid ${colors.border}`
              }}
            >
              <div 
                className="projects__image"
                style={{ backgroundImage: `url(${project.image})` }}
              />
              <div className="projects__content">
                <h3>{project.title}</h3>
                <p>{project.description}</p>
                <div className="projects__tags">
                  {project.tags.map(tag => (
                    <span key={tag} className="projects__tag">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;